import {
  formatPecentageValueWithOneDecimal,
  createKpiTileItem,
} from '../../../../utils/helper';
import { KpiHandler, IPCSummaryData } from './types';
import { KpiData } from 'components/redesign/KpiTile/types';

const agentRuntimeInPercentage: KpiHandler = {
  type: 'KpiTile',
  handler: (data: IPCSummaryData): KpiData => {
    const { agentRuntimePercentage } = data;

    const formattedValue = formatPecentageValueWithOneDecimal(
      agentRuntimePercentage
    );

    return createKpiTileItem('Agent Runtime', formattedValue, []);
  },
};

export default agentRuntimeInPercentage;
